import { TabbedItemPage } from './TabbedItemPage';
import { SuperannuationPlaceholder } from './SuperannuationPlaceholder';
import { SuperRunDashboard } from '../features/superRunDashboard/SuperRunDashboard';
import { ContributionAudit } from '../features/contributionAudit/ContributionAudit';

const tabContent = {
  'super-run-dashboard': <SuperRunDashboard />,
  'saff-message-archive': <SuperannuationPlaceholder title="SAFF Message Archive" />,
  'invariant-breach-queue': <SuperannuationPlaceholder title="Invariant Breach Queue" />,
  'contribution-audit': <ContributionAudit />,
  'cap-tracker': <SuperannuationPlaceholder title="Cap Tracker" />,
};

export const PayrollSuperannuationPage = () => (
  <TabbedItemPage itemPath="/payroll/superannuation" tabContentOverrides={tabContent} preserveSearch />
);
